import { css } from "@emotion/react";

const BREAKPOINT = 45;

export const mobile = (styles: any) => css`
  @media (max-width: ${BREAKPOINT - 1}rem) {
    ${css(styles)};
  }
`;

export const desktop = (styles: any) => css`
  @media (min-width: ${BREAKPOINT}rem) {
    ${css(styles)};
  }
`;

// usage ${mobile(css`display: flex;`)}
